<div class="bu-selection-wrapper">
    <div class="main-content">
        <!-- Header with Tabs and Actions -->
        <div class="wells-action-buttons">
            <div class="tabs-container" *ngIf="isLoggedIn">
                <button class="tab-button" [ngClass]="{'active': activeTab === 'legal'}" (click)="selectTab('legal')">
                    <span class="material-symbols-outlined">visibility</span>
                    Legal
                </button>
                <button class="tab-button" [ngClass]="{'active': activeTab === 'developer'}" (click)="selectTab('developer')" *ngIf="userRole === 'admin'">
                    <span class="icon">assignment</span>
                    Developer
                </button>
            </div>
            <div class="action-buttons">
                <button class="btn btn-refresh">
                    <span class="material-icons">refresh</span>
                    Refresh
                </button>
                <button *ngIf="userSelectedFromDate || userSelectedToDate || userSelectedCounterparty" class="btn btn-logout" (click)="clearAllFilters()">
                    <span class="material-icons">clear</span>
                    Clear all
                </button>
                <button class="btn btn-logout" (click)="logout()">
                    <span class="material-icons">power_settings_new</span>
                    Logout
                </button>
            </div>
        </div>

        <!-- Filter Section -->
        <div class="filter-section">
            <div class="filter-group">
                <label for="from-date" class="filter-label">From</label>
                <div class="filter-input-wrapper">
                    <input type="date" id="from-date" class="filter-input" [(ngModel)]="fromDate" (change)="onFromDateChanged()">
                    <button *ngIf="userSelectedFromDate && fromDate" type="button" class="filter-clear-btn" (click)="clearFromDate()" title="Clear From date">
                        <span class="material-icons">close</span>
                    </button>
                </div>
            </div>
            <div class="filter-group">
                <label for="to-date" class="filter-label">To</label>
                <div class="filter-input-wrapper">
                    <input type="date" id="to-date" class="filter-input" [(ngModel)]="toDate" (change)="onToDateChanged()">
                    <button *ngIf="userSelectedToDate && toDate" type="button" class="filter-clear-btn" (click)="clearToDate()" title="Clear To date">
                        <span class="material-icons">close</span>
                    </button>
                </div>
            </div>
            <div class="filter-group counterparty">
                <label for="counterparty" class="filter-label">Counterparty</label>
                <div class="filter-input-wrapper">
                    <select id="counterparty" class="filter-input" [(ngModel)]="selectedCounterparty" (change)="onCounterpartyChanged()">
                        <option value="">Choose options</option>
                        <option *ngFor="let cp of counterparties" [value]="cp">{{ cp }}</option>
                    </select>
                    <button *ngIf="userSelectedCounterparty && selectedCounterparty" type="button" class="filter-clear-btn" (click)="clearCounterparty()" title="Clear Counterparty">
                        <span class="material-icons">close</span>
                    </button>
                </div>
            </div>
        </div>

        <!-- KPI Dashboard -->
        <div class="kpi-dashboard">
            <!-- KPI Section Header -->
            <div class="kpi-section-header">
                <h2 class="kpi-title">Legal Operations — KPIs</h2>
            </div>

            <!-- KPI Cards Container (Flex) -->
            <div class="kpi-cards-container">
                <!-- Loading Skeleton -->
                <ng-container *ngIf="isLoadingKPIs; else kpiCardsContent">
                    <div class="kpi-card" *ngFor="let i of [1,2,3,4,5,6,7,8,9]">
                        <div class="kpi-card-header">
                            <span class="kpi-label skeleton-text" style="width: 60%; height: 14px;"></span>
                            <span class="kpi-info-icon skeleton-text" style="width: 22px; height: 22px; border-radius: 50%;"></span>
                        </div>
                        <p class="kpi-value skeleton-text" style="width: 40%; height: 38px;"></p>
                    </div>
                </ng-container>

                <!-- Actual KPI Cards -->
                <ng-template #kpiCardsContent>
                    <div class="kpi-card">
                        <div class="kpi-card-header">
                            <span class="kpi-label">NDA Mails Processed</span>
                            <span class="kpi-info-icon" title="All emails in filter window (NEW_NDA + REVIEW_NDA + OUT_OF_SCOPE)">?</span>
                        </div>
                        <p class="kpi-value">{{ kpis.ndaMailsProcessed }}</p>
                    </div>

                    <div class="kpi-card">
                        <div class="kpi-card-header">
                            <span class="kpi-label">New NDA Requests</span>
                            <span class="kpi-info-icon" title="Emails classified as NEW_NDA — counterparty requesting a fresh Chevron NDA template">?</span>
                        </div>
                        <p class="kpi-value">{{ kpis.newNdaRequests }}</p>
                    </div>

                    <div class="kpi-card">
                        <div class="kpi-card-header">
                            <span class="kpi-label">Review NDA</span>
                            <span class="kpi-info-icon" title="Emails classified as REVIEW_NDA — counterparty submitted a redlined document">?</span>
                        </div>
                        <p class="kpi-value">{{ kpis.reviewNda }}</p>
                    </div>

                    <div class="kpi-card">
                        <div class="kpi-card-header">
                            <span class="kpi-label">Out of Scope</span>
                            <span class="kpi-info-icon" title="Emails classified as OUT_OF_SCOPE — not an NDA or not actionable">?</span>
                        </div>
                        <p class="kpi-value">{{ kpis.outOfScope }}</p>
                    </div>

                    <div class="kpi-card">
                        <div class="kpi-card-header">
                            <span class="kpi-label">Hard Escalations (Redlines)</span>
                            <span class="kpi-info-icon" title="Individual redline decisions where escalation.level == HARD — attorney review required">?</span>
                        </div>
                        <p class="kpi-value">{{ kpis.hardEscalations }}</p>
                    </div>

                    <div class="kpi-card">
                        <div class="kpi-card-header">
                            <span class="kpi-label">No Escalation (Redlines)</span>
                            <span class="kpi-info-icon" title="Individual redline decisions where escalation.level == NONE — no human review needed">?</span>
                        </div>
                        <p class="kpi-value">{{ kpis.noEscalation }}</p>
                    </div>

                    <div class="kpi-card">
                        <div class="kpi-card-header">
                            <span class="kpi-label">Avg Processing Time</span>
                            <span class="kpi-info-icon" title="📅 Per-email median: time from Exchange receivedDateTime to Graph createReply completing. High values (e.g. 200hr) occur when the reconcile script processes emails that arrived days earlier.">?</span>
                        </div>
                        <p class="kpi-value">{{ kpis.avgProcessingTime }}</p>
                    </div>
                    <div class="kpi-card">
                        <div class="kpi-card-header">
                            <span class="kpi-label">Unique Senders</span>
                            <span class="kpi-info-icon" title="Distinct senders that have sent to the shared mailbox">?</span>
                        </div>
                        <p class="kpi-value">{{ kpis.uniqueSenders }}</p>
                    </div>
                    <div class="kpi-card">
                        <div class="kpi-card-header">
                            <span class="kpi-label">Avg Mails/Senders</span>
                            <span class="kpi-info-icon" title="Total emails ÷ unique known senders">?</span>
                        </div>
                        <p class="kpi-value">{{ kpis.avgMailsPerSender }}</p>
                    </div>
                </ng-template>
            </div>
        </div>

        <!-- Mailbox Senders Table Section -->
        <div class="mailbox-senders-section">
            <!-- Collapsible Header -->
            <div class="collapsible-header" (click)="toggleMailboxSenders()">
                <span class="collapse-icon" [ngClass]="{'collapsed': !showMailboxSenders}">▼</span>
                <span class="material-icons section-icon">mail</span>
                <h3 class="section-title">Mailbox Senders ({{ mailboxSenders.length }})</h3>
            </div>

            <!-- Collapsible Content -->
            <div class="collapsible-content" *ngIf="showMailboxSenders">
                <div class="table-wrapper">
                    <table class="mailbox-table">
                    <thead>
                        <tr>
                            <th class="col-name">Name</th>
                            <th class="col-email">Email</th>
                            <th class="col-mails">Mails Sent</th>
                            <th class="col-lastseen">Last Seen</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let sender of mailboxSenders">
                            <td class="col-name">{{ sender.name }}</td>
                            <td class="col-email">{{ sender.email }}</td>
                            <td class="col-mails">{{ sender.mailsSent }}</td>
                            <td class="col-lastseen">{{ sender.lastSeen }}</td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- Email Graphs Component -->
        <div class="mailbox-senders-graphs-section">
            <div *ngIf="isLoadingEmailVolume" class="loading-skeleton" style="height: 400px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite;"></div>
            <app-email-graphs *ngIf="!isLoadingEmailVolume" [emailVolumeByDay]="emailVolumeByDay" [emailsByDayOfWeek]="emailsByDayOfWeek"></app-email-graphs>
        </div>
        <!-- Volume & Pipeline / Risk & Prediction Tabs Component -->
        <div class="analytics-tabs-section">
            <div *ngIf="isLoadingAnalytics" class="loading-skeleton" style="height: 500px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite;"></div>
            <app-volume-risk-tabs 
                *ngIf="!isLoadingAnalytics"
                [emailsByDayOfWeek]="emailsByDayOfWeek" 
                [volumeTrend]="volumeTrend" 
                [classificationSplit]="classificationSplit" 
                [templateDistribution]="templateDistribution" 
                [counterpartyNegotiations]="counterpartyNegotiations"
                [escalationDistribution]="escalationDistribution"
                [agingQueue]="agingQueue"
                [escalationByCounterparty]="escalationByCounterparty"
                [frictionClauses]="frictionClauses"
                [escalationTrend]="escalationTrend"
                [escalationCategories]="escalationCategories">
            </app-volume-risk-tabs>
        </div>
    </div>
</div>
